import { HttpErrorResponse } from "@angular/common/http";
import { AdministratorList } from "src/app/_models/Administrator";
import { Userprofile } from "src/app/_models/Userprofile";

export interface ListAdministratorState {
  crudAdministratorLoader: boolean;
  crudAdministratorError: HttpErrorResponse;
  deleteIsSuccessful: boolean;

  crudResult: Userprofile;
  administratorTableRecords: AdministratorList[];
  administratorRecordsLength: number;
  administratorTableError: HttpErrorResponse;

  administratorTableLoader: boolean;
  tableAdministratorError: boolean;
  isInitialLoadFlowReset: boolean;

  updateAdminAccountStatusLoader: boolean;
  isAdminAccountStatusUpdateSuccessful: boolean;
  updateAdminAccountStatusError: HttpErrorResponse;
}

export const initialListAdministratorState: ListAdministratorState = {
  crudAdministratorLoader: false,
  crudAdministratorError: null,
  deleteIsSuccessful: false,

  crudResult: null,
  administratorTableRecords: [],
  administratorRecordsLength: 0,
  administratorTableError: null,

  administratorTableLoader: false,
  tableAdministratorError: null,
  isInitialLoadFlowReset: false,

  updateAdminAccountStatusLoader: false,
  isAdminAccountStatusUpdateSuccessful: false,
  updateAdminAccountStatusError: null
};
